import * as React from 'react';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import StringResourceManager, { GetString } from '../StringResourceManager';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { useDispatch, useSelector } from 'react-redux';
import { createStyles, makeStyles } from '@material-ui/core';
import { Button } from '@progress/kendo-react-buttons';
import { ApplicationState } from '../../store';
import { NBCItem, NBCProfile } from '../../Interfaces/NBC/NBCItem';
import { applySnapshot } from '../../store/NBC/NBCAction';
import { Dispatch } from 'redux';
import {
  RadioGroup,
  RadioGroupChangeEvent,
} from '@progress/kendo-react-inputs';
import { DateTimePicker, DateTimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { Error } from '@progress/kendo-react-labels';
import { getDateWithoutTimezone } from '../../utils/utils';

const useStyles = makeStyles(theme =>
  createStyles({
    cancelButton: {
      width: '180px',
      border: '1px solid #000000',
    },
    buttonStyle: {
      alignItems: 'flex-end',
      marginTop: 33,
    },
    modalContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);

interface Props {
  handleCloseDialog: (open: boolean) => void;
  modalTitle:string;
  snapShotType:string;
}

const ApplySnapshotDialog: React.FC<Props> = ({
  handleCloseDialog,
  modalTitle,
  snapShotType,
}): React.ReactElement => {
  const classes = useStyles();

  const dispatch: Dispatch<any> = useDispatch();

  const YES = GetString('YES');

  const NO = GetString('NO');
  const SET_SCHEDULE = GetString("SET_SCHEDULE");
  const INVALID_DATE_SCHEDULE = GetString('INVALID_DATE_SCHEDULE')

  const profileNames: NBCProfile[] = useSelector(
    (state: ApplicationState) => state.nbcReducer.profileNames
  );

  const selectedProfile: string | undefined = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedProfile
  );

  const handleClose = () => {
    handleCloseDialog(false);
  };

  const [snapShotSchedule, setSnapShotSchedule] = React.useState<any>();

  const scheduleOptionData = [
    { label: GetString('APPLY_NOW'), value: GetString('APPLY_NOW') },
    { label: GetString('APPLY_SCHEDULE'), value: GetString('APPLY_SCHEDULE') },
  ];

  const [selectedOption, setSelectedOption] = React.useState(
    scheduleOptionData[0].value
  );

  const APPLY_NOW = GetString('APPLY_NOW');

  const handleConfirm = () => {
    const profile: NBCProfile | undefined = profileNames.find(
      item => item.ProfileUuid === selectedProfile
    );

    const scheduledDateTime =
    selectedOption === APPLY_NOW ? new Date() : snapShotSchedule;

    if (profile) {
      applySnapshot(dispatch, profile, getDateWithoutTimezone(scheduledDateTime), selectedOption === APPLY_NOW ? true : false, snapShotType);
    }
    handleCloseDialog(false);
  };

  
  const [errorMsg, setErrorMsg] = React.useState(false);

  const scheduleOptionChange = (e: RadioGroupChangeEvent) => {
    setSelectedOption(e.value);
    setErrorMsg(false);
  };

  const dateSelectedOnChange = (e: DateTimePickerChangeEvent) =>{
    if (!e.value) return; 

    if (e.value < new Date()) {
      setErrorMsg(true);
    } else {
      setSnapShotSchedule(e.value);
      setErrorMsg(false);
    }
  }

  return (
    <Dialog
      width="25vw"
      title={
        <StringResourceManager
          variant="body1"
          style="commandLabel"
          stringKey={modalTitle}
          gutterBottom={true}
        />
      }
      onClose={handleClose}
    >
      <div className={classes.modalContainer}>
        <div style={{ marginBottom: '20px' }}>
          <StringResourceManager stringKey={'SNAPSHOT_SCHEDULED'} />
          {selectedOption === GetString('APPLY_SCHEDULE') ? (
            <div>
            <DateTimePicker
              width={220}
              label={SET_SCHEDULE}
              onChange={dateSelectedOnChange}
            />
             {errorMsg && (
            <Error direction='start'>{INVALID_DATE_SCHEDULE}</Error>)}
            </div>
          ) : null}
          <br />
          <RadioGroup
            data={scheduleOptionData}
            value={selectedOption}
            onChange={scheduleOptionChange}
            layout="horizontal"
          />
        </div>
        <div>
          {GetString('APPLY_SNAPSHOT_MODAL_MSG')} "
          {
            profileNames.find(item => item.ProfileUuid === selectedProfile)
              ?.ProfileName
          }
          "
          <br />
          <br />
          {GetString('APPLY_SNAPSHOT_CONFIRM_MSG')}
        </div>
      </div>
      <DialogActionsBar>
        <Button
          onClick={handleConfirm}
          disabled={
            selectedOption === GetString('APPLY_SCHEDULE') &&
            snapShotSchedule === undefined
              ? true
              : false
          }
        >
          {YES}
        </Button>
        <Button onClick={handleClose}>{NO}</Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default ApplySnapshotDialog;
